import PATH from "constants/path";
import React from "react";

import { isAuthenticated } from "utils/common";

function DoneContact() {
  return (
    <div className={isAuthenticated() ? "w-80" : "container px-3 px-lg-0"}>
      <div className="fs-20 fs-sm-18 fw-600 sp-14 text-center py-3 py-md-4">
        お問い合わせ
      </div>

      <div className="p-15">
        <div className="px-4 px-md-0 my-3 my-md-4 fw-400 sp-14">
          <div>お問い合わせいただき、ありがとうございます。</div>
          <div className="my-3">
            内容を確認の上、メールにて折り返しご連絡をさせていただきます。
            <br />
            なお、ご返信までに数時間～数日かかる場合がございますのでご了承ください。
            <br />
            ※お問い合わせ内容によっては、メールではなく電話でお返事させていただく場合もございます。
          </div>
        </div>

        <div className="my-5 text-center">
          <a href={PATH.TOP} className="btn-custom">
            トップページに戻る
          </a>
        </div>
      </div>
    </div>
  );
}

export default DoneContact;
